import heavyWeight from '../assets/products/heavy_weight.webp';
import stopper from '../assets/products/stopper.webp';
import booster from '../assets/products/booster.webp';

const PRODUCTS = [
  {
    id: 'heavyWeight',
    product: 'El-kanis Heavy Weight™',
    productImage: heavyWeight,
    keyFeatures: '',
    productInfo: 'This is an organic fat-powered vitamin extract for improved animal production, weight gain, good water intake, rapid growth, strong bone and good carcasses quality. It helps to control wet litter, mortality control and balances calcium phosphorus.',
    benefits: [
      'Increases egg production',
      'Increases immunity to stress',
      'Prevents bacterial infection in Chicks, Grower and Broiler',
      'Improves absorptions of nutrients from Gastro-Intestinal Tract',
      'Also Improves FCR and Weight Gains',
    ],
    howItWorks: [
      'EL-KANIS - HEAVY WEIGHT™ Organic boosters provide a number of essential nutrients that chickens need to stay healthy and grow properly.',
      "They can help improve your chickens' immune system, helping them stay healthy and productive.",
      'EL-KANIS - HEAVY WEIGHT™ Organic chicken growth boosters are made with natural ingredients, so they are a more sustainable choice than chemical additives.',
    ],
    dosage: [
      'From day old - 2weeks 550g (1sachet) to 100kg (4bags) of feed',
      'From 3weeks - Table size (Maturity) 550g (1sachet) to 50kg (2bags) of feed',
      'N/B: No withdrawal Period',
    ],
  },
  {
    id: 'stopper',
    product: 'El-kanis Stopper Solution™',
    productImage: stopper,
    productInfo: 'This is an organic plant-based natural solution for protecting broilers, broiler-breeders and non-caged layers against Eimeria infection, Fowl typhoid, Coccidiosis, Diarrhea and Chronic Respiratory Disease (CRD).',
    keyFeatures: '',
    benefits: [
      'El-Kanis Stopper Solution™ is the safest and most effective coccidiostat used in poultry farming. It effectively eliminates all strains of coccidian protozoa.',
      'It helps in eliminating the contaminants in the atmosphere. As a result, birds are not exposed to large volumes of sporulated oocysts, effectively preventing infections.',
      'Due to the extensive use of various anticoccidial drugs, drug-resistant parasites are on the rise. Compared to the other anticoccidial drugs, EL-kanis Stopper Solution™ is highly effective in preventing and treating coccidiosis.',
    ],
    howItWorks: [
      'Prevents bad effects of salmonellosis, colibacillosis, clostridium, etc.',
      'Safe and effective for all species of coccidian',
      'Herbal remedy against Ascites, Gout, and Gumboro',
    ],
    dosage: [
      'Treatment: 20ml (20% of the bottle) to 4liters of water for 3-5 days consecutively',
      'Prevention: 10ml (10% of the bottle) to 4litres of water for 3-5 days consecutively',
      'N/B: Shake well before use',
    ],
  },
  {
    id: 'booster',
    product: 'El-kanis Optimum Booster Solution™',
    productImage: booster,
    productInfo: "This organic plant-based product provides vitamins for animals' performance. It is very effective in supporting animal immunity and health. It is fortified with amino acids and vitamins and causes rapid weight gain and double breast development.",
    keyFeatures: [
      'Unique blend of all essential nutrients - amino 1 acids, vitamins, electrolytes & minerals',
      'Powdered formula - superior mixability for feed application',
      'Energy enhancer supplies energy during critical 3 phase',
      'Probiotic as a part of pack in separate chamber 4 for long term viability',
      'Please Read All Label Information on Delivery',
    ],
    benefits: [
      'Accelerates growth of animals at early stage of life',
      'Helps In faster recovery from diseases and infections',
      'Enables uniform and fast growth to marketable body weight',
    ],
    howItWorks: [
      'EL-KANIS - HEAVY WEIGHT™ Organic boosters provide a number of essential nutrients that chickens need to stay healthy and grow properly.',
      "They can help improve your chickens' immune system, helping them stay healthy and productive.",
      'EL-KANIS - HEAVY WEIGHT™ Organic chicken growth boosters are made with natural ingredients, so they are a more sustainable choice than chemical additives.',
    ],
    dosage: [
      'From 1-3 weeks of age; 150g (1sachet) to 25kg (1 bag) of feed',
      'From 3 weeks - Table size (Maturity) 150g (1sachet) to 50kg (2bags) of feed.',
      'N/B: No withdrawal Period.',
    ],
  },
];

export default PRODUCTS;
